<app-item class="rounded-border-box">
	<app-svg-icon name="attach-sharp"></app-svg-icon>
	<app-item-label truncate>{{ combinedAttachment.name }}</app-item-label>
	@if (combinedAttachment.attachment) {
		<app-item-note>{{ combinedAttachment.createdDate | isoDateToRelative: 'dd/MM/yyyy' : TimeDisplay.Before }}</app-item-note>
		<app-chip startIcon="person-sharp" [label]="combinedAttachment.attachment.createdByUserName | userInitials" clickable (click)="handleUserClick($event)" @enterFadeOnly></app-chip>
		@if (isReadOnly) {
				<app-svg-icon class="hoverable-element" name="arrow-down-circle-outline" (click)="downloadAttachment()"></app-svg-icon>
		}
		@else {
			<app-svg-icon class="hoverable-element" name="close-sharp" (click)="removeAttachment()" @enterFadeOnly></app-svg-icon>
		}
	}
	@else if (!isReadOnly) {
		<app-item-note>{{ combinedAttachment.loaded / combinedAttachment.total * 100 | number : '1.0-0' }}%</app-item-note>
	}
</app-item>
<ion-popover class="popover-menu popover-alt" #popover [isOpen]="popoverIsOpen" [showBackdrop]="false" alignment="end" (didDismiss)="popoverIsOpen = false">
	<ng-template>
		<div class="popover-menu-content">
			<app-item><app-item-label>{{ combinedAttachment.attachment?.createdByUserName }}</app-item-label></app-item>
		</div>
	</ng-template>
</ion-popover>